<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.ssoContentId]"
		[controlName]="ContentCsvKeys.ssoContentId"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.ssoContentId]"
		[required]="form.get(ContentCsvKeys.ssoContentId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.ssoActivityId]"
		[controlName]="ContentCsvKeys.ssoActivityId"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.ssoActivityId]"
		[required]="form.get(ContentCsvKeys.ssoActivityId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.defaultLangId]"
		[controlName]="ContentCsvKeys.defaultLangId"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.defaultLangId]"
		[required]="form.get(ContentCsvKeys.defaultLangId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.displayOrder]"
		[controlName]="ContentCsvKeys.displayOrder"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.displayOrder]"
		[required]="form.get(ContentCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.isInstruction]"
		[controlName]="ContentCsvKeys.isInstruction"
		[required]="form.get(ContentCsvKeys.isInstruction)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-content-type-dropdown-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.contentType]"
		[controlName]="ContentCsvKeys.contentType"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.contentType]"
		[required]="form.get(ContentCsvKeys.contentType)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.featuredMode]"
		[controlName]="ContentCsvKeys.featuredMode"
		[required]="form.get(ContentCsvKeys.featuredMode)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-scoring-method-dropdown-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.scoringMethod]"
		[controlName]="ContentCsvKeys.scoringMethod"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.scoringMethod]"
		[required]="form.get(ContentCsvKeys.scoringMethod)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-skill-code-dropdown-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.skillCode]"
		[controlName]="ContentCsvKeys.skillCode"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.skillCode]"
		[required]="form.get(ContentCsvKeys.skillCode)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	@if (rubricCode(); as rubricCode) {
		<app-rubric-level-dropdown-field
			[rubricCode]="rubricCode"
			[label]="CONTENT_CSV_LABELS[ContentCsvKeys.rubricLevel]"
			[controlName]="ContentCsvKeys.rubricLevel"
			[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.rubricLevel]"
			[required]="form.get(ContentCsvKeys.rubricLevel)?.hasValidator(Validators.required) ? true : false"
			[formGroup]="form"
		/>
	}

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enName]"
		[controlName]="ContentCsvKeys.enName"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enName]"
		[required]="form.get(ContentCsvKeys.enName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enImageUri]"
		[controlName]="ContentCsvKeys.enImageUri"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enImageUri]"
		[required]="form.get(ContentCsvKeys.enImageUri)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enContentUri]"
		[controlName]="ContentCsvKeys.enContentUri"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enContentUri]"
		[required]="form.get(ContentCsvKeys.enContentUri)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enContentTags]"
		[controlName]="ContentCsvKeys.enContentTags"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enContentTags]"
		[required]="form.get(ContentCsvKeys.enContentTags)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enDescriptionShort]"
		[controlName]="ContentCsvKeys.enDescriptionShort"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enDescriptionShort]"
		[required]="form.get(ContentCsvKeys.enDescriptionShort)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.enDescriptionHtml]"
		[controlName]="ContentCsvKeys.enDescriptionHtml"
		[placeholder]="CONTENT_CSV_LABELS[ContentCsvKeys.enDescriptionHtml]"
		[required]="form.get(ContentCsvKeys.enDescriptionHtml)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="CONTENT_CSV_LABELS[ContentCsvKeys.active]"
		[controlName]="ContentCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
